module.exports = __webpack_public_path__ + "static/media/hand_type.3d3cdc4b.png";